module.exports = __webpack_public_path__ + "static/media/college-board.193c9c18.jfif";